import { BoardTypeEnum } from 'modules/core/domain/interfaces/supabase/overlay/auxiliary-types';
import { Values } from 'modules/template-editor/domain/interface/form/board';
import { MatchEventType } from 'shared/types/match-event';

export interface BoardSettings {
  name: string;
  type?: BoardTypeEnum;
  events: MatchEventType[];
  duration?: number;
  isFavorite: boolean;
}

/**
 * Настройки табло из значений `BoardForm` — всё, что пользователь может поменять в форме.
 *
 * События приходят пустым массивом, а не `undefined`, если тип не `events`: `copyBoard`
 * подставляет поле исходного табло на `undefined`, и копия унаследовала бы события оригинала.
 */
function boardSettingsFromValues(values: Values, isFavorite: boolean): BoardSettings {
  const type = values.type?.value;
  const isEvents = type === 'events';
  const isCarousel = type === 'carousel';
  const duration = Number(values.duration);

  return {
    name: values.name.trim(),
    type,
    events: isEvents ? (values.events ?? []).map((event) => event.value) : [],
    duration: (isEvents || isCarousel) && values.duration && !isNaN(duration) ? duration : undefined,
    isFavorite: isEvents ? false : isFavorite,
  };
}

export default boardSettingsFromValues;
